import { DirectoryRecordData } from 'api/types/data/directory/directory';
import { getDirectoryFieldValue } from 'modules/directory/common/helpers';
import { useField } from 'modules/order/common/forms/orderForm';
import { useOrderContext } from 'modules/order/common/providers/OrderProvider';

export const useFinancialInstrumentSection = () => {
  const { schemas, directories } = useOrderContext();

  const { financialInstruments } = directories;

  const { helpers: securityTypeHelpers } = useField(
    'financialInstrument.securityType'
  );
  const { helpers: issuerHelpers } = useField('financialInstrument.issuer');

  const { helpers: nominalValueHelpers } = useField(
    'financialInstrument.nominalValue'
  );

  const onChangeIsin = (
    params: {
      value: string;
      label: string;
      record?: DirectoryRecordData;
    } | null
  ) => {
    if (params?.record) {
      if (!financialInstruments) {
        return;
      }

      const { record } = params;

      const securityTypeField = record.fields.find(
        (field) => field.name === financialInstruments.securityType.fieldName
      );

      const schema = schemas?.find(
        (schema) =>
          schema.name === financialInstruments.isin.directorySchemaName
      );

      securityTypeHelpers.setValue(
        securityTypeField && schema
          ? getDirectoryFieldValue(
              securityTypeField,
              schema,
              schemas!
            )?.toString()
          : ''
      );

      const issuerField = record.fields.find(
        (field) => field.name === financialInstruments.issuer.fieldName
      );

      issuerHelpers.setValue(
        issuerField && schema
          ? getDirectoryFieldValue(issuerField, schema, schemas!)?.toString()
          : ''
      );

      const nominalValueField = record.fields.find(
        (field) => field.name === financialInstruments.nominalValue.fieldName
      );

      nominalValueHelpers.setValue(
        (nominalValueField?.value as string) || undefined
      );
    } else {
      securityTypeHelpers.setValue('');
      issuerHelpers.setValue('');
      nominalValueHelpers.setValue(undefined);
    }
  };

  return { onChangeIsin, financialInstruments };
};
